const regExp = {
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  hexColor: /^#[0-9A-F]{6}$/i,
  id: /^[a-npr-zA-NPR-Z]{3}\d{6}$/,
  letter: /^([a-zA-ZąęćżźńłóśĄĆĘŁŃÓŚŹŻ\-_, ]+)+$/,
  password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
  pesel:
    /^\d{2}([02][1-9]|[13][0-2])([0][1-9]|[1][0-9]|[2][0-9]|[3][0-1])\d{5}$/,
  phone: /^\+?[0-9]{1,3}[\s-]?\(?\d{1,4}\)?[\s-]?\d{1,4}[\s-]?\d{1,4}$/,
  postCode: /^#([0-9a-fA-F]{3}){1,2}$/,
};

export default regExp;
